import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
    EventType,
    PublicClientApplication,
    AuthenticationResult
} from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";
import { BrowserRouter } from "react-router";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { UserProvider } from "./components/UserContext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";

dayjs.locale("en-gb");

const msalInstance = new PublicClientApplication(msalConfig);

// Keep the active account in sync after login/redirect completes
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        msalInstance.setActiveAccount(payload.account);
    }
});

// On page load, restore an account if one is already cached
const existingAccounts = msalInstance.getAllAccounts();
if (!msalInstance.getActiveAccount() && existingAccounts.length > 0) {
    msalInstance.setActiveAccount(existingAccounts[0]);
}

function RootProviders() {
    const { instance, accounts } = useMsal();

    const getAccessToken = React.useCallback(async () => {
        const account = instance.getActiveAccount() ?? accounts[0];
        if (!account) return null;

        const res = await instance.acquireTokenSilent({
            ...loginRequest,
            account
        });

        return res.accessToken;
    }, [instance, accounts]);

    return (
        <UserProvider getAccessToken={getAccessToken}>
            <BrowserRouter>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                    <App />
                </LocalizationProvider>
            </BrowserRouter>
        </UserProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <RootProviders />
        </MsalProvider>
    </React.StrictMode>
);